module.exports = __webpack_public_path__ + "img/50.1599943f.jpg";